export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true&
// module id = 78
// module chunks = 0